import ProductManuallyModal from './ProductManuallyModal';

export default ProductManuallyModal;